import { useNavigate } from 'react-router-dom';

// import directly from interface to avoid circular dependency
import { Hooks } from 'interface/sharedJsInterface';

const { React: ReactHooks, Subscriptions } = Hooks;
const { useDidUpdateEffect } = ReactHooks;
const { useSelectedQuestionBankWithSubscriptions } = Subscriptions;


export function useGoHomeOnQuestionBankChange() {
  const navigate = useNavigate();
  const questionBank = useSelectedQuestionBankWithSubscriptions();

  const onQuestionBankChange = () => navigate('/');
  useDidUpdateEffect(onQuestionBankChange, [questionBank.get('id')]);
}
